import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

document.querySelectorAll('.product_categories_slider')?.forEach((element) => {
    const paginationEl = element.parentElement.querySelector(
        '.highlighted_categories-pagination-container',
    );
    const nextEl = element.parentElement.parentElement.parentElement.querySelector(
        '.highlighted_categories-navigation-right',
    );
    const prevEl = element.parentElement.parentElement.parentElement.querySelector(
        '.highlighted_categories-navigation-left',
    );

    return new Swiper(element, {
        modules: [Navigation, Pagination, Autoplay],
        slidesPerView: 'auto',
        spaceBetween: 8,
        breakpoints: {
            768: {
                spaceBetween: 16,
            },
        },
        pagination: {
            el: paginationEl,
            clickable: true,
            renderBullet: (index, className) => {
                return `<span class="${className}"></span>`;
            },
        },
        autoplay: {
            delay: 3000,
        },
        navigation: {
            nextEl,
            prevEl,
        },
    });
});
